/* AQUESCE theme JS — vanilla, no dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Pause offscreen animations (battery) ---------- */
  function initOffscreenPause() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-offscreen', !e.isIntersecting);
      });
    }, { rootMargin: '300px 0px' });
    document.querySelectorAll('.aq-io').forEach(function (el) { io.observe(el); });
    window.AQ = window.AQ || {};
    window.AQ.observeMotion = function (el) { io.observe(el); };
  }

  /* ---------- 2. Pause everything when the tab is hidden ---------- */
  document.addEventListener('visibilitychange', function () {
    root.classList.toggle('aq-tab-hidden', document.hidden);
  });

  /* ---------- 3. Cart drawer: open / close / focus trap / Esc ---------- */
  var drawer, panel, lastFocus;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(trigger) {
    if (!drawer) return;
    lastFocus = trigger || document.activeElement;
    drawer.hidden = false;
    root.classList.add('aq-locked');
    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var close = drawer.querySelector('[data-cart-close].aq-icon-btn');
      if (close) close.focus();
    });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    root.classList.remove('aq-locked');
    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () { drawer.hidden = true; };
    if (reduceMotion) done(); else setTimeout(done, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !drawer || drawer.hidden) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function initDrawer() {
    drawer = document.getElementById('aq-cart-drawer');
    if (!drawer) return;
    panel = drawer.querySelector('.aq-drawer__panel');

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) {
        // On the cart page itself, let the link work normally.
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        openDrawer(opener);
        return;
      }
      if (e.target.closest('[data-cart-close]')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
      trapFocus(e);
    });

    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* Public hooks for later phases (Ajax cart, add-to-bag) */
  window.AQ = window.AQ || {};
  window.AQ.openCart = openDrawer;
  window.AQ.closeCart = closeDrawer;
  window.AQ.setCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    var live = document.querySelector('[data-cart-announce]');
    if (live) live.textContent = n + (n === 1 ? ' item' : ' items') + ' in bag';
  };

  /* ---------- 4. Quantity steppers ---------- */
  function initSteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-inc], [data-qty-dec]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 9;
      var val = parseInt(input.value, 10) || min;
      val += btn.hasAttribute('data-qty-inc') ? 1 : -1;
      input.value = Math.min(Math.max(val, min), max);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function init() { initOffscreenPause(); initDrawer(); initSteppers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
